function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.7539,
  cy: 12,
  r: 12,
  fill: "#EBF3FD"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.50391 4.13867L8.00391 5.0047",
  stroke: "#4290F3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6875 2.98242V3.98242",
  stroke: "#4290F3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0039 4.13867L17.5039 5.0047",
  stroke: "#4290F3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("mask", {
  id: "path-5-inside-1",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.8306 18.0936C15.8464 17.0886 16.4248 16.1941 17.133 15.4766C18.23 14.3654 18.9071 12.8386 18.9071 11.1537C18.9071 7.75512 16.152 5 12.7534 5C9.35473 5 6.59961 7.75512 6.59961 11.1537C6.59961 12.8386 7.27675 14.3654 8.37373 15.4766C9.09188 16.2042 9.67648 17.1137 9.67648 18.136C9.67648 18.1508 9.67659 18.1655 9.67682 18.1802V19.0003C9.67682 20.1048 10.5722 21.0002 11.6768 21.0002H13.8306C14.9351 21.0002 15.8306 20.1048 15.8306 19.0003V18.0936Z"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M15.8306 18.0936L14.8307 18.0778L14.8306 18.0857V18.0936H15.8306ZM17.133 15.4766L16.4213 14.7741L17.133 15.4766ZM8.37373 15.4766L9.0854 14.7741L8.37373 15.4766ZM9.67682 18.1802H10.6768V18.1726L10.6767 18.1651L9.67682 18.1802ZM16.8304 18.1094C16.8404 17.4813 17.2111 16.821 17.8446 16.1792L16.4213 14.7741C15.6385 15.5672 14.8525 16.6959 14.8307 18.0778L16.8304 18.1094ZM17.8446 16.1792C19.1189 14.8883 19.9071 13.1121 19.9071 11.1537H17.9071C17.9071 12.5651 17.3411 13.8424 16.4213 14.7741L17.8446 16.1792ZM19.9071 11.1537C19.9071 7.20284 16.7043 4 12.7534 4V6C15.5997 6 17.9071 8.30741 17.9071 11.1537H19.9071ZM12.7534 4C8.80245 4 5.59961 7.20284 5.59961 11.1537H7.59961C7.59961 8.30741 9.90702 6 12.7534 6V4ZM5.59961 11.1537C5.59961 13.1121 6.38785 14.8883 7.66206 16.1792L9.0854 14.7741C8.16565 13.8424 7.59961 12.5651 7.59961 11.1537H5.59961ZM7.66206 16.1792C8.3051 16.8306 8.67648 17.4998 8.67648 18.136H10.6765C10.6765 16.7277 9.87866 15.5777 9.0854 14.7741L7.66206 16.1792ZM8.67648 18.136C8.67648 18.1558 8.67663 18.1756 8.67693 18.1953L10.6767 18.1651C10.6766 18.1554 10.6765 18.1457 10.6765 18.136H8.67648ZM10.6768 19.0003V18.1802H8.67682V19.0003H10.6768ZM13.8306 20.0002H11.6768V22.0002H13.8306V20.0002ZM14.8306 18.0936V19.0003H16.8306V18.0936H14.8306ZM13.8306 22.0002C15.4874 22.0002 16.8306 20.6571 16.8306 19.0003H14.8306C14.8306 19.5525 14.3828 20.0002 13.8306 20.0002V22.0002ZM8.67682 19.0003C8.67682 20.6571 10.02 22.0002 11.6768 22.0002V20.0002C11.1245 20.0002 10.6768 19.5525 10.6768 19.0003H8.67682Z",
  fill: "#4290F3",
  mask: "url(#path-5-inside-1)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M12.041 17.79H15.4033",
  stroke: "#4290F3",
  strokeLinecap: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M16.6489 12.3649C16.812 11.8532 16.8728 11.3143 16.8276 10.779C16.7825 10.2438 16.6324 9.72267 16.3859 9.24544C16.2586 8.99904 16.1069 8.76683 15.9335 8.55214M13.9941 7.22559C14.2688 7.31315 14.5328 7.4293 14.7819 7.57172",
  stroke: "#4290F3",
  strokeLinecap: "round"
});

function SvgLightBulb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulb);
export default __webpack_public_path__ + "static/media/light-bulb.9d5ad726.svg";
export { ForwardRef as ReactComponent };